<p id="timer" [ngClass]="{'yellow': minutes > 2, 'red': minutes > 4}">{{showTime}}</p>
